import PropTypes from "prop-types"
import * as React from "react"
import Header from "../sections/headerV2/header"
const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
